import styled from 'styled-components';
import { colors } from 'assets/styled/tokens';

export const EventCard = styled.div<{ borderLeft?: string; backgroundColor?: string }>`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  height: 100px;
  border-radius: 4px;
  padding: 6px;
  border-left: 4px solid ${({ borderLeft }) => borderLeft};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
`;

export const CardFirstRow = styled.div<{ fontColor?: string }>`
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${({ fontColor }) => fontColor};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
  }
`;

export const StatusIcon = styled.div<{ color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 4px;
  font-size: 10px;
  font-weight: 700;
  color: white;
`;

export const CardSecondRow = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${colors.carbon};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  min-width: 0;
  flex-shrink: 1;
`;

export const CardThirdRow = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${colors.carbon};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  min-width: 0;
  flex-shrink: 1;
`;

export const CardFourthRow = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${colors.carbon};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LineSeparetor = styled.div<{ separetorColor?: string }>`
  width: 100%;
  height: 1px;
  background-color: ${({ separetorColor }) => separetorColor};
`;

export const CardFifthRow = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${colors.carbon};
`;

export const ExecPhoto = styled.img`
  border-radius: 50%;
  height: 20px;
  width: 20px;
`;

export const ExecPhotoWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  overflow: hidden;
`;

export const MoreExecContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > div {
    display: flex;
    span {
      display: flex;
      margin-left: 6px;
      align-items: center;
    }
  }
`;

const OCCURRENCE_BORDER_COLOR = '#85BFE4';

// Wrapper externo: borda azul fixa em todos os lados, fundo branco
export const OccurrenceOuterCard = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border-radius: 4px;
  padding: 3px;
  border: 2px solid ${OCCURRENCE_BORDER_COLOR};
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 3px;
  cursor: pointer;
`;

// Card interno: igual ao card de atividade mas com altura menor
export const SmallActivityCard = styled.div<{ borderLeft?: string; backgroundColor?: string }>`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border-radius: 2px;
  padding: 4px;
  border-left: 4px solid ${({ borderLeft }) => borderLeft};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 86px;
`;

export const OccurrenceCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
`;

export const OccurrenceCardHeaderLeft = styled.div<{ iconColor?: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex: 1;
  svg {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    path {
      fill: ${({ iconColor }) => iconColor || colors.carbon};
    }
  }
`;

export const CqaText = styled.span<{ fontColor?: string }>`
  font-family: Roboto;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  color: ${({ fontColor }) => fontColor || colors.carbon};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
